import React from 'react';
import { Alert } from 'antd';
import type { AlertProps } from 'antd';
import { useTranslation } from 'react-i18next';

interface ErrorAlertProps extends Omit<AlertProps, 'type' | 'description' | 'title' | 'message'> {
  /** Headline, e.g. "Failed to load jobs". */
  title: React.ReactNode;
  /** The query or mutation error; its message becomes the description. */
  error: unknown;
  /** Description when the error carries no message; defaults to a generic "Unknown error". */
  fallbackDescription?: React.ReactNode;
}

/**
 * Error banner for a failed query: the given title plus the error's message as description.
 */
export const ErrorAlert: React.FC<ErrorAlertProps> = ({ title, error, fallbackDescription, showIcon = true, ...rest }) => {
  const { t } = useTranslation('common');
  const description =
    error instanceof Error && error.message ? error.message : fallbackDescription ?? t('errors.unknown', 'Unknown error');
  return <Alert type="error" showIcon={showIcon} title={title} description={description} {...rest} />;
};
